<template lang="html">
  <v-container text-xs-center>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>About Us</h1>
        <v-card>
          <v-card-text class="primary--text px-0">
            We started this music school.
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {}
</script>

<style lang="css" scoped>
</style>
